import { render } from "./ProfileNotification.vue?vue&type=template&id=6c74cea8&scoped=true"
import script from "./ProfileNotification.vue?vue&type=script&lang=js"
export * from "./ProfileNotification.vue?vue&type=script&lang=js"

import "./ProfileNotification.vue?vue&type=style&index=0&id=6c74cea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c74cea8"]])

export default __exports__